var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnderstandRemote4Icon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8361_2001)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_8361_2001)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.2179 10.9194C6.51933 11.2724 5.73352 11.4157 4.95532 11.332C4.17712 11.2482 3.43979 10.941 2.83232 10.4475C2.22486 9.95393 1.77323 9.2951 1.53194 8.55052C1.29066 7.80595 1.27004 7.00745 1.47256 6.25141L5.08056 7.21808C4.72755 6.51951 4.58426 5.73371 4.66801 4.95551C4.75175 4.1773 5.05894 3.43997 5.55249 2.83251C6.04605 2.22504 6.70487 1.77341 7.44945 1.53213C8.19403 1.29084 8.99252 1.27022 9.74856 1.47275L8.7819 5.08075C9.48046 4.72773 10.2663 4.58445 11.0445 4.66819C11.8227 4.75193 12.56 5.05912 13.1675 5.55267C13.7749 6.04623 14.2266 6.70506 14.4678 7.44963C14.7091 8.19421 14.7298 8.99271 14.5272 9.74875L10.9192 8.78208C11.2722 9.48064 11.4155 10.2664 11.3318 11.0447C11.248 11.8229 10.9409 12.5602 10.4473 13.1677C9.95374 13.7751 9.29492 14.2267 8.55034 14.468C7.80576 14.7093 7.00727 14.7299 6.25123 14.5274L7.2179 10.9194Z",
    stroke: "#9810FA",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 8V8.00667",
    stroke: "#9810FA",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8361_2001"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_8361_2001"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnderstandRemote4Icon);
export default __webpack_public_path__ + "static/media/understand_remote_4_icon.359767082612553af5445689acff9516.svg";
export { ForwardRef as ReactComponent };